import { BotAction } from "./BotAction";
import { Icon } from "@zapier/design-system";
import { useChatbotContext } from "./ChatbotContext";

type RunZapBotMessageProps = {
  buttonText: string;
  message: { content?: string };
  onClick: () => void;
};

export function RunZapBotMessage({
  buttonText,
  message,
  onClick,
}: RunZapBotMessageProps) {
  const { emitConsumerInteractionEvent, projectId, pageId, isEmbedded } =
    useChatbotContext();
  return (
    <BotAction
      type="button"
      onClick={() => {
        onClick();
        emitConsumerInteractionEvent?.({
          interaction_raw_text: message.content,
          interaction_goal: "run zap with bot response",
          event_action: "click",
          interfaces_project_id: projectId,
          interfaces_page_id: pageId,
          interfaces_component_type: "chatbot",
          embedded_flag: isEmbedded,
        });
      }}
    >
      <Icon name="miscBoltAltFill" size={17} />
      {buttonText}
    </BotAction>
  );
}
